export const projectNavigatePath = (project) => {
  return `/project-details/${project?.code}${
    project?.SEO?.slug
      ? "/" + project?.SEO?.slug?.trim()?.split(" ")?.join("-")
      : "/" + project?.name?.trim()?.split(" ")?.join("-")
  }`;
};
export const blogNavigatePath = (blog) => {
  return `/blog-details/${blog?.code}${
    blog?.SEO?.slug
      ? "/" + blog?.SEO?.slug?.trim()?.split(" ")?.join("-")
      : "/" + blog?.title?.trim()?.split(" ")?.join("-")
  }`;
};
